import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../shared/http-service.class';
import { MyLBApiConfiguration } from '../mylb-api.configuration';
import { ITimezoneMigrationSummary, ITimezoneMigrationResult, IUserTimezoneMigrationStatus } from '../interfaces';

@Injectable({
	providedIn: 'root'
})
export class TimezoneMigrationService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'TimezoneMigration');
	}

	/**
	 * Get a quick summary of migration impact (record counts only)
	 * Used to determine if migration is needed before showing confirmation
	 */
	public getMigrationSummary(userID: number, timeZoneID: number): Observable<ITimezoneMigrationSummary> {
		return this.get<ITimezoneMigrationSummary>(`${this.serviceUrl}/summary/${userID}/${timeZoneID}`);
	}

	/**
	 * Confirm timezone and automatically execute migration if needed
	 * Main endpoint - combines timezone update + migration in one transaction
	 */
	public confirmTimezoneWithMigration(userID: number, timeZoneID: number): Observable<ITimezoneMigrationResult> {
		return this.post<ITimezoneMigrationResult>(`${this.serviceUrl}/confirm/${userID}/${timeZoneID}`, null);
	}

	/**
	 * Check if user has already completed migration
	 */
	public getMigrationStatus(userID: number): Observable<IUserTimezoneMigrationStatus> {
		return this.get<IUserTimezoneMigrationStatus>(`${this.serviceUrl}/status/${userID}`);
	}
}
